import { useTranslation } from 'react-i18next';
import { ExternalReactRenderers } from '../../../components/Editor/types';
import cn from 'classnames';
import { DaDeviationAttrs, DaDeviationOptions } from '../deviation';
import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import { useWidth } from '../hooks/useWidth';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';

import s from './Viewer.scss';

export interface Props {
  externalRenderers: ExternalReactRenderers;
  node: TipTapBaseNode;
}

const Viewer = (props: Props) => {
  const { t } = useTranslation();
  const attrs: DaDeviationAttrs = props.node.attrs as DaDeviationAttrs;
  const { alignment, deviation } = attrs;
  const Renderer = props.node.externalRenderers?.deviation;
  const config = props.node.extensionConfig?.deviation as DaDeviationOptions;
  const align =
    alignment === 'left'
      ? s['left']
      : alignment === 'right'
      ? s['right']
      : s['center'];

  const { width } = useWidth(
    attrs.width ?? config.defaultWidth ?? 780,
    config.defaultWidth,
    config.smallMedia ?? false,
    attrs.alignment,
    props.node.containerWidth
  );

  const Deviation = (
    <figure
      className={s['deviation-figure']}
      data-da-type="da-deviation"
      data-deviation={JSON.stringify(deviation)}
      data-width={attrs.width}
      data-link={attrs.link}
      data-alignment={attrs.alignment}
    >
      <ErrorBoundary
        debugComponent="editorExtDeviationViewer"
        humanError={t('common.editor.deviation.humanError')}
      >
        <Renderer
          deviation={attrs.deviation}
          width={width}
          extOptions={config}
          link={attrs.link}
        />
      </ErrorBoundary>
    </figure>
  );

  return (
    <div
      key={`img-${width}`}
      className={cn(
        s['deviation-container'],
        align,
        config?.smallMedia && s['small-media'],
        s[`preset-${props.node.presetId}`]
      )}
    >
      {Deviation}
    </div>
  );
};

export default Viewer;
